// @ts-nocheck
//统一url处理
import Vue from 'vue'
Vue.prototype.$version = 'v1.22';
  var server = 'https://api.mychildren365.com/';
//  var server = 'https://localhost:9188/';

// if (window['_url']) {
//     if (window._url['serverUrl']) {
//         server = window._url['serverUrl'];
//     }
// }

var serverAdmin = server;
var serverHome = server;
var serverImg = 'https://pic.mychildren365.com/';
var serverDefault = serverAdmin;
Vue.prototype.$isTest = false;

//获得处理过的地址，主要用于获得图片的地址
Vue.prototype.$getUrl = function (url) {

    if (!url) {
        return '';
    }
    //判断是不是相对路径 ./，如果是就不需要添加
    if (url.indexOf('./') >= 0) {
        //是相对路径 ./，所以直接返回
        return url;
    }
    //开始判断是不是http开头，如果是就不再添加头了
    var _url;
    if (url.indexOf('http') == -1) {
        let head = serverImg;
        //取出index.php
        // head = head.replace('', '');
        _url = head + url;
    } else {
        _url = url;
    }
    // npm run  serve
    return _url;

}

// 


//服务器地址
Vue.prototype.$server = server;
Vue.prototype.$serverAdmin = serverAdmin;
Vue.prototype.$serverHome = serverHome;
Vue.prototype.$serverDefault = serverDefault;


//上传文件地址
// var serverDefault = 'http://server.followenjoy.cn/index.php/';
Vue.prototype.$serverUpFile = serverDefault + "Use/upFile";
Vue.prototype.$serverUpImage = serverDefault + "Use/upImage";

// 版本号





let Url = {
    serverUrl: server,
    devUrl: server,
    imageUrl: 'https://pic.mychildren365.com/',
   // ThisUrl: 'http://h5dev.ruibei365.com/'
}
export default Url;
